__turbopack_context__.v({
  "button": "NewsList-module-scss-module__JBQ-iG__button",
  "news": "NewsList-module-scss-module__JBQ-iG__news",
});
